/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Col, Modal, Row } from 'antd';
// import styles from './style.module.scss';
// import './index.scss'
import styled from 'styled-components';
import ResumeUploadAvatar from './upload-button';
import ModalCloseIcon from '../../icon';

const StyledModal = styled(Modal)`
  background-color: #303843;
  font-size: 32px;
  color: white;
  padding-bottom: 0px;
  .ant-modal-close {
    position: absolute;
    top: 30px;
    right: 40px;
  }
  .ant-modal-content {
    background-color: #303843;
    padding: 10px;
  }
  .ant-modal-title {
    color: white;
    margin: 20px;
    font-size: 20px;
  }
  div {
    color: white;
  }
  .ant-modal-header {
    background-color: #303843;
  }
  .ant-upload-wrapper {
    margin: 20px;
  }
  .anticon {
    color: white;
  }
`;
interface ResumeUploadModalProps {
  isModalOpen: boolean;
  setIsModalOpen: any;
}
const ResumeUploadModal: React.FC<ResumeUploadModalProps> = ({
  isModalOpen,
  setIsModalOpen,
}: ResumeUploadModalProps) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <StyledModal
        footer={null}
        closable
        title="Upload Resume"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closeIcon={<ModalCloseIcon />}
      >
        <Row justify="center">
          <Col>
            <ResumeUploadAvatar />
          </Col>
        </Row>
      </StyledModal>
    </>
  );
};

export default ResumeUploadModal;
